<template>
  <div class="flex flex-col min-h-0 min-w-0 w-full h-full">
    <div
      class="border-b border-mid-neutral-50 h-14 flex items-center justify-between px-6 bg-white z-10 shrink-0"
    >
      <div class="flex items-center gap-2 text-dark-neutral-500">
        <span class="material-symbols-outlined">water_drop</span>
        <h2 class="font-semibold">Cleaning</h2>
      </div>
    </div>
    <Specifications :composable="composable" />
  </div>
</template>
<script setup lang="ts">
import { Specifications, useSpecifications } from "specifications";
import { useCleaningSpecificationsState } from "states/cleaning";
import { lifecyclePhasesState } from "states/lifecyclePhases";
import { variantsState } from "states/variants";

const variants = variantsState();
const { phases } = lifecyclePhasesState();

const cleaningSpecs = useCleaningSpecificationsState();
const composable = useSpecifications({
  variants,
  phases,
  specificationsState: cleaningSpecs,
});
</script>
